import { utils } from 'vevet';
import { vevetApp } from './vevet';

export const clampScopeEasing = (progress: number, scope: [number, number]) =>
  utils.math.easing(
    utils.math.clampScope(progress, scope),
    vevetApp.prop.easing
  );
